// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumbs_container__V6WrJ","breadCrumbLink":"BreadCrumbs_breadCrumbLink__3YreO","ltr":"BreadCrumbs_ltr__1PFGl","breadCrumb":"BreadCrumbs_breadCrumb__3R2aI"};